// src/Pages/Version/index.js
import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton,
    DeleteButton,
    ShowButton,
    CreateButton,
    TopToolbar,
    usePermissions,
    Create,
    SimpleForm,
    TextInput,
    required,
    minLength,
    maxLength,
    Edit,
    DateInput,
    useRecordContext,
    Show,
    SimpleShowLayout
} from 'react-admin';

// Validador personalizado para formato de versión X.Y
const validateVersion = (value) => {
    if (!value) return 'La versión es requerida';
    
    // Validar formato de versión (ej: 1.0, 2.1, 10.5, etc.)
    const versionRegex = /^\d+\.\d+$/;
    if (!versionRegex.test(value)) {
        return 'El formato debe ser X.Y (ej: 1.0, 2.1)';
    }
    
    return undefined;
};

// Componente para título dinámico
const VersionTitle = () => {
    const record = useRecordContext();
    return <span>Versión {record ? `"${record.version}"` : ''}</span>;
};

// Acciones del toolbar
const VersionActions = () => (
    <TopToolbar>
        <CreateButton />
    </TopToolbar>
);

// Componente de Lista
export const VersionList = (props) => {
    //const { permissions } = usePermissions();
    
    return (
        <List
            {...props}
            actions={<VersionActions />}
            sort={{ field: 'created_at', order: 'DESC' }}
            perPage={25}
        >
            <Datagrid>
                <TextField source="id" label="ID" />
                <TextField source="version" label="Versión" />
                <DateField 
                    source="created_at" 
                    label="Fecha de Creación"
                    showTime
                />
                <ShowButton />
                <EditButton />
                <DeleteButton />
            </Datagrid>
        </List>
    );
};

// Componente de Creación
export const VersionCreate = (props) => (
    <Create {...props} title="Crear Nueva Versión">
        <SimpleForm>
            <TextInput
                source="version"
                label="Versión"
                validate={[
                    required('La versión es requerida'),
                    minLength(3, 'La versión debe tener al menos 3 caracteres'),
                    maxLength(255, 'La versión no puede exceder 255 caracteres'),
                    validateVersion
                ]}
                helperText="Formato: X.Y (ej: 1.0, 2.1)"
                fullWidth
            />
        </SimpleForm>
    </Create>
);

// Componente de Edición
export const VersionEdit = (props) => (
    <Edit {...props} title={<VersionTitle />}>
        <SimpleForm>
            <TextInput
                source="version"
                label="Versión"
                validate={[
                    required('La versión es requerida'),
                    minLength(3, 'La versión debe tener al menos 3 caracteres'),
                    maxLength(255, 'La versión no puede exceder 255 caracteres'),
                    validateVersion
                ]}
                helperText="Formato: X.Y (ej: 1.0, 2.1)"
                fullWidth
            />
            <DateInput
                source="created_at"
                label="Fecha de Creación"
                disabled
                helperText="Este campo no se puede modificar"
            />
        </SimpleForm>
    </Edit>
);

// Componente de Visualización
export const VersionShow = (props) => (
    <Show {...props} title={<VersionTitle />}>
        <SimpleShowLayout>
            <TextField source="id" label="ID" />
            <TextField source="version" label="Versión" />
            <DateField 
                source="created_at" 
                label="Fecha de Creación"
                showTime
            />
        </SimpleShowLayout>
    </Show>
);